import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from '../globalComponents/NativeOverrides';
import Colors from '../constants/Colorsv2';

const Table = ({ data, first_key, keys_hidden}: any) => {
    const keys = Object.keys(data[0]);
    const orderedKeys = reorderKeys(keys, first_key, keys_hidden);

    const headerWidths = Object.keys(data[0]).reduce((widths, key) => {
        const headerWidth = key.length * 4; // Adjust the multiplier as needed
        const fieldWidth = Math.max(...data.map((row:any) => String(row[key]).length)) * 4; // Adjust the multiplier as needed
        const maxWidth = Math.max(headerWidth, fieldWidth);
        return { ...widths, [key]: maxWidth };
      }, {});

      const prettyKey = (key:string) => {
        let split_key = key.split('_')
        return split_key.join(' ').toUpperCase()
      }

    return (
        <View style={styles.table}>
            <View style={styles.tableHeader}>
                {orderedKeys.map((key) => (
                    <Text size={12} color={Colors.brand.midnight} weight='semibold' textAlign='center' style={[styles.headerCell, { minWidth: headerWidths[key] }]} key={key}>
                    {prettyKey(key)}
                    </Text>
                ))}
            </View>
            <View style={styles.tableRows}>
                {data.map((row:any, index:number) => (
                <View style={styles.tableRow} key={index}>
                    {orderedKeys.map((key) => (
                    <Text size={12} color={Colors.brand.midnight} weight='regular' textAlign='center' style={[styles.tableCell, { minWidth: headerWidths[Object.keys(row)[index]] }]} key={index}>
                        {row[key]}
                    </Text>
                    ))}
                </View>
                ))}
            </View>
        </View>
    );

}

const styles = StyleSheet.create({
    table: {
      borderWidth: 1,
      borderRadius: 8,
      borderColor: Colors.shades.shade600,
      marginVertical: 10,
    },
    tableHeader: {
      flexDirection: 'row',
      alignItems:'flex-end',
      backgroundColor: Colors.shades.shade100,
    },
    headerCell: {
      flex: 1,
      padding: 5,
      minWidth: 50
    },
    tableRows: {},
    tableRow: {
      flexDirection: 'row',
      borderBottomWidth: 1,
      borderBottomColor: Colors.shades.shade600,
    },
    tableCell: {
      flex: 1,
      padding: 5,
      minWidth:50
    },
  });


const reorderKeys = (keys, firstKey, keysHidden) => {
    const filteredKeys = keys.filter(key => !keysHidden.includes(key));
    const index = filteredKeys.indexOf(firstKey);
    if (index > -1) {
        filteredKeys.splice(index, 1);
        filteredKeys.unshift(firstKey);
    }
    return filteredKeys;
};

export default Table